"use strict";

exports.__esModule = true;
exports.default = void 0;
const browser = typeof window !== "undefined";
var _default = browser;
exports.default = _default;